import { Rows } from 'base/ui/layout';
import { menuItem } from 'base/ui/menu_model';
import { SelectButton } from 'base/ui/select';
import { TextTinyLight } from 'base/ui/typography';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SectionEditingActions } from '../editing_actions/section';
import { Section, SectionColor, SectionRef, SECTION_COLORS } from '../model';
import { SECTION_COLOR_TITLE, SECTION_COLOR_VALUES } from '../section_colors';
import { GlobalSectionsButton } from './global_sections';
import styles from './section_sitemap.css';

export const SitemapEditSection = observer(function _SitemapEditSection({
  sel,
  section,
  sectionEditing,
}: {
  sel: { section: SectionRef };
  section: Section;
  sectionEditing: SectionEditingActions;
}) {
  const { color } = section;
  return (
    <Rows spacing={16}>
      <GlobalSectionsButton
        sref={sel.section}
        sectionEditing={sectionEditing}
      />
      <Rows spacing={8}>
        <TextTinyLight color="grey">Color</TextTinyLight>
        <SelectButton
          menu={sectionColorMenu({
            color,
            onChange: sectionEditing.setColor,
          })}
          searchPlaceholder="Search colors..."
        />
      </Rows>
    </Rows>
  );
});

function ColorCircle({ color }: { color: SectionColor | undefined }) {
  return (
    <div
      className={classNames(styles.circle, color == null && styles.isWhite)}
      style={{
        ['--color' as string]: color ? SECTION_COLOR_VALUES[color] : 'white',
      }}
    />
  );
}

const COLOR_CIRCLES = Object.fromEntries(
  SECTION_COLORS.map((c) => [c, () => <ColorCircle color={c} />]),
) as any as Record<SectionColor, React.ComponentType>;
const DEFAULT_COLOR_CIRCLE = () => <ColorCircle color={undefined} />;

export function sectionColorMenu({
  color,
  onChange,
}: {
  color: SectionColor | undefined;
  onChange(color: SectionColor | undefined): void;
}) {
  return [
    menuItem({
      label: 'Default',
      searchSynonyms: 'white',
      icon: DEFAULT_COLOR_CIRCLE,
      onClick: () => onChange(undefined),
      checked: color == null,
    }),
    ...SECTION_COLORS.map((c) =>
      menuItem({
        icon: COLOR_CIRCLES[c],
        label: SECTION_COLOR_TITLE[c],
        onClick: () => onChange(c),
        checked: color === c,
      }),
    ),
  ];
}
